import * as React from "react";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import {
  IconButton,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { addDoc, collection, deleteDoc, doc } from "firebase/firestore";
import { db } from "firebaseApp";
import { colors } from "colors";
import ConfirmModal from "components/react-lib/generic-ui/ConfirmModal";
import DeleteIcon from "@mui/icons-material/Delete";
import { useDispatch, useSelector } from "react-redux";
import { editorActions } from "store/editor";
import { useAuth } from "context/react-lib/firebase-auth/AuthProvider";
import EditDocumentMenuItem from "components/react-lib/generic-ui/firestore/EditDocumentMenuItem";
import FileCopyIcon from '@mui/icons-material/FileCopy';
import AddLinkIcon from '@mui/icons-material/AddLink';
import { modalsActions } from "store/react-lib/generic-ui/modals";
import { COLLECTIONS } from "firebaseCollections";

export default function DocumentMenu({ 
  previous,
  next,
  document,
  color = colors.white,
}) {

  const auth = useAuth();
  const uid = auth.currentUser.uid;

  const dispatch = useDispatch();

  const [anchorEl, setAnchorEl] = React.useState(null);
  const [deleting, setDeleting] = React.useState(false);
  const [duplicating, setDuplicating] = React.useState(false);

  const open = Boolean(anchorEl);

  const activeDocument = useSelector((state) => state.editor.activeDocument);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleDelete = async () => {
    try {
      setDeleting(true);
      const docRef = doc(
        db,
        COLLECTIONS.mdDocuments,
        document.id,
      );
      await deleteDoc(docRef);
      handleClose();
      if(document.id === activeDocument.id) {
        if(previous) {
          dispatch(editorActions.setActiveDocument(previous));
        } else if(next) {
          dispatch(editorActions.setActiveDocument(next));        
        } else {
          dispatch(editorActions.setActiveDocument(null));
        }
      }
    } catch (error) {
      console.log(error);
    } finally {
      setDeleting(false);
    }
  };

  const handleDuplicate = async () => {
    try {
      setDuplicating(true);
      const {id, ...rest} = activeDocument;
      const docSnap = await addDoc(collection(db, COLLECTIONS.mdDocuments), {
        ...rest,
        name: activeDocument.name + " copy"
      });
      dispatch(editorActions.setActiveDocument({
        id: docSnap.id,
        ...docSnap.data(),
      }));
      handleClose();
    } catch(error) {
      console.log(error);
    } finally {
      setDuplicating(false);
    }
  }

  const handleAttachClick = () => {
    dispatch(modalsActions.openModal("attachFileToDocumentModal"));
    dispatch(editorActions.setAttachmentTarget(document.id));
    handleClose();
  }


  return (
    <div>
      <ConfirmModal
        open={deleting}
        setOpen={setDeleting}
        title="Confirm"
        message="Are you sure to delete this document?"
        confirmAction={handleDelete}
        cancelAction={handleClose}
      />
      <IconButton onClick={handleClick} color={color}>
        <MoreVertIcon />
      </IconButton>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}
      >
        <MenuItem onClick={handleAttachClick}>
          <ListItemIcon>
            <AddLinkIcon color="text" fontSize="small" />
          </ListItemIcon>
          <ListItemText color="text">Attach file</ListItemText>
        </MenuItem>
        <MenuItem onClick={handleDuplicate}>
          <ListItemIcon>
            <FileCopyIcon color="text" fontSize="small" />
          </ListItemIcon>
          <ListItemText color="text">Duplicate</ListItemText>
        </MenuItem>
        <EditDocumentMenuItem
          label="Rename"
          documentRef={doc(db, COLLECTIONS.mdDocuments, document.id)}
          iconProps={{
            color: "text",
          }}
          fieldsToEdit={["name"]}
          closeMenu={handleClose}
          fieldConfig={{
            name: {props: {color: "secondary"}},
          }}
        />
        <MenuItem onClick={() => setDeleting(true)}>
          <ListItemIcon>
            <DeleteIcon color="text" fontSize="small" />
          </ListItemIcon>
          <ListItemText color="text">Delete</ListItemText>
        </MenuItem>
      </Menu>
    </div>
  );
}
